
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/services/mobile-app-development",
      function () {
        return require("private-next-pages/services/mobile-app-development/index.tsx");
      }
    ]);
  